import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import LandingPage from './LandingPage'
import LogoEditor from './LogoEditor'
import Navbar from './components/Navbar'

const App = () => {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/create" element={<LogoEditor />} />
          </Routes>
        </main>
      </div>
    </Router>
  )
}

export default App
